export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/PaperSourceLogo-2db7201fb1d4cbbd03496ee43c7d74f4.png";